import { useAuthStore } from '@/stores/modules/auth'
import type { RouteMetaMiddleware } from '@/types/shims-vue-router'

export const auth = () => {
  const middleware: RouteMetaMiddleware = (params) => {
    const authStore = useAuthStore(params?.store)

    const authCheck = authStore.role !== 'GUEST'

    if (!authCheck) {
      params?.redirect({
        name: 'login',
        query: { redirect: params?.urlPath },
      })

      return false
    }

    return true
  }

  return middleware
}
